import EnviromentConfig from "../../configs/enviromentConfig";
const API_URL = EnviromentConfig.API_URL;

export const api = {
      facturas: {
        async getTotalFacturasUsuario(usuarioid) {
            const res = await fetch(`${API_URL}/api/facturas/${usuarioid}/`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        },
        async getFacturasSuministro(suministroId, CliCod) {
            const res = await fetch(`${API_URL}/api/facturas/${suministroId}/${CliCod}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        },
        async getFacturasTotalUsuario(userId) {
            const res = await fetch(`${API_URL}/api/facturas/usuario/${userId}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        }

        
     },
     pvs: {
        async generarLinkDePago(data) {
            const res = await fetch(`${API_URL}/api/pagar-facturas`, {
              method: "POST",
              headers: { "Content-Type": "application/json",
              Authorization: localStorage.getItem('token'),
              },
              body: JSON.stringify(data),
            });
            if (!res.ok) throw await res.json();
            return await res.json(); 
        },
     },
     }